
export { getPermissions } from "/app/shared/services/auth/src/services/permissions.ts"